// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"84518c69","683":"6d0b38d2","827":"dc021ba1"}[chunkId] + ".chunk.js";
};